import type { DataTableProviderFilterStateValue } from '@/components/common/DataTableProvider/types';

export type PipelineContextFilter = {
  id: string;
  name: string;
};

export function withPipelineContextFilter(
  filters: Map<string, DataTableProviderFilterStateValue>,
  context?: PipelineContextFilter | null
): Map<string, DataTableProviderFilterStateValue> {
  if (!context?.id || filters.has('pipeline_id')) {
    return filters;
  }

  const next = new Map(filters);
  next.set('pipeline_id', {
    value: context.id,
    label: context.name || context.id
  });
  return next;
}
